import { Avatar, Box, Typography, Stack } from '@mui/material';
import { ReactElement } from 'react';
import { useRecoilValue } from 'recoil';

import { userAuthInfoSelector } from '@app/domain/app';
import { Organization } from '@app/types/organization';

interface CardPartOrganizationProps {
  organization: Organization;
}

export function CardPartOrganization({
  organization,
}: CardPartOrganizationProps): ReactElement {
  const authInfo = useRecoilValue(userAuthInfoSelector);
  const orgInfoArray: string[] = [
    organization.customFields?.addressByCity || '',
    organization.customFields?.access || '',
    authInfo ? organization.name : '',
  ].filter((i) => i);

  return (
    <Stack direction="row" spacing={1}>
      <Avatar
        variant="square"
        sx={{ borderRadius: '8px', height: 32, width: 32 }}
      >
        {organization.name ? organization.name.substring(0, 1) : ''}
      </Avatar>
      <Typography variant="body3" component="div" color="textSecondary">
        {orgInfoArray.map((value, index) => (
          <Box key={index}>{value}</Box>
        ))}
      </Typography>
    </Stack>
  );
}
